module.exports = __webpack_public_path__ + "img/tr.657ea685.svg";